// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// 1. As importações agora são muito mais limpas, vindo dos nossos "barrel files"
import { Navbar, FloatingSocialIcons, ScrollToTop, FooterSection } from './components';
import { HomePage, ProgramsFullSection, TermosDeUso, PoliticaDePrivacidade, RoomDetailPage, SaoLourencoPage, EstruturaPage, PoliticaCancelamento   } from './pages';

import './App.css';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // 2. A lógica agora força o Navbar a ser sólido em QUALQUER página que não seja a Home.
  // Isso é mais robusto e funciona para as páginas de acomodação, legais, etc.
  const forceNavbarNotTop = !isHomePage;

  return (
    <> {/* Usamos Fragment para não adicionar uma <div> extra desnecessária */}
      <Navbar forceNotTop={forceNavbarNotTop} />
      <FloatingSocialIcons />
      
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/programacaocompleta" element={<ProgramsFullSection />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/sao-lourenco" element={<SaoLourencoPage />} />
          <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
          <Route path="/politica-de-cancelamento" element={<PoliticaCancelamento />} />
          <Route path="/acomodacoes/:roomType" element={<RoomDetailPage />} />
          <Route path="/estrutura" element={<EstruturaPage />} />
        </Routes>
      </main>
      
      <FooterSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App"> {/* A classe .App agora envolve tudo */}
        <ScrollToTop />
        <AppContent />
      </div>
    </Router>
  );
}

export default App;